import { render } from "./FollowTarget.vue?vue&type=template&id=fa4b4432&scoped=true&bindings={}"
import script from "./FollowTarget.vue?vue&type=script&lang=ts"
export * from "./FollowTarget.vue?vue&type=script&lang=ts"

import "./FollowTarget.vue?vue&type=style&index=0&id=fa4b4432&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa4b4432"

export default script